import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { Workspace } from '@workspaces/models/workspaces';
import { TimeAgoPipe } from '@workspaces/utils/pipes/workspace-date.pipe';
import { MatTooltip } from '@angular/material/tooltip';
import { MatChipListbox, MatChip } from '@angular/material/chips';
import { CommonModule } from '@angular/common';
import { WorkspaceStatusClassPipe } from '@workspaces/utils/pipes/workspace-status-class.pipe';
import { WorkspaceStatusPipe } from '@workspaces/utils/pipes/workspace-status.pipe';

@Component({
  selector: 'app-workspace-card',
  templateUrl: './workspace-card.component.html',
  styleUrls: ['./workspace-card.component.scss', '../../../global-workspace-styles.scss'],
  standalone: true,
  imports: [
    MatCardModule,
    RouterModule,
    MatIconModule,
    MatButtonModule,
    TimeAgoPipe,
    MatTooltip,
    MatChipListbox,
    MatChip,
    CommonModule,
    WorkspaceStatusPipe,
    WorkspaceStatusClassPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkspaceCardComponent {
  @Input({ required: true }) element!: Workspace;
  @Input() disabled = true;
}
